import { Component, ViewChild, ElementRef } from "@angular/core";
import { Location } from "@angular/common";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { MESSAGE_CODE } from "src/app/shared/constant/message-constant";
import { TOAST } from "src/app/shared/constant/primeng-constants";
import { LoadingState } from "src/app/shared/html-parts/loading/loading-state";
import {
  MessageData,
  ToastMessageData,
} from "src/app/shared/html-parts/message-common/message-data";
import { CommonService } from "src/app/shared/service/common.service";
import { DbOperationService } from "src/app/shared/service/db-operation.service";
import {
  API_URL_CHAT_STATUS,
  API_URL_GENERATE_CHAT_LIST,
  API_URL_GENERATE_CHAT_LIST_2,
  API_URL_GET_UPLOAD_URL,
  API_URL_MATCH_CHAT_DETAIL,
  API_URL_UPDATE_MATCH_STATUS,
} from "manager/http-constants";
import { API_RESPONSE } from "src/app/shared/constant/api-constant";
import {
  CHATSTATUSES,
  CONSTANT,
  DICID_NUMBER,
  LOADING_KEY,
  MATCH_TYPE,
  ROLES,
} from "src/app/shared/constant/constant";
import { PlatformComponent } from "../platform.component";
import { ApprovalDialogComponent } from "../common/approval-dialog/approval-dialog.component";
import { LoginService } from "../../../shared/service/login.service";
import moment from "moment";
import { Subscription } from "rxjs";
import { ConfirmRejectMatchDialogComponent } from "../common/confirm-reject-match-dialog/confirm-reject-match-dialog.component";
import { MenuItem, MessageService } from "primeng/api";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { map } from "rxjs/operators";
import { ImgPreviewComponent } from "../common/img-preview/img-preview.component";
import { ConsultationDialogComponent } from "../common/consultation-dialog/consultation-dialog.component";

@Component({
  selector: "app-c601",
  templateUrl: "./c601.component.html",
  styleUrls: ["./c601.component.scss", "../platform.component.scss"],
})

/**
 * 提案詳細
 */
export class C601Component extends PlatformComponent {
  /** 共通部品_承認時ダイアログ */
  @ViewChild(ApprovalDialogComponent)
  approvalDialogComponent: ApprovalDialogComponent;
  @ViewChild(ImgPreviewComponent)
  imgPreviewComponent: ImgPreviewComponent;

  @ViewChild("chatList") chatList: ElementRef<HTMLDivElement>;
  @ViewChild("listPanelChat") listPanelChat: ElementRef<HTMLDivElement>;

  @ViewChild("messageItem") messageItem: ElementRef<HTMLDivElement>;
  /** 削除ダイアログ */
  @ViewChild(ConfirmRejectMatchDialogComponent)
  confirmRejectMatchDialogComponent: ConfirmRejectMatchDialogComponent;

  @ViewChild(ConsultationDialogComponent)
  consultationDialogComponent: ConsultationDialogComponent;

  isShowTimeDialog: boolean = false;
  currentChat: Subscription;

  // member_id of user login
  member_id: any;
  listStatus: any[] = [
    CHATSTATUSES.REQUEST_PROPOSAL,
    CHATSTATUSES.ADJUSTMENT,
    CHATSTATUSES.DECISION,
    CHATSTATUSES.IMPLEMENTED,
    CHATSTATUSES.END,
  ];
  chatFileErrorMSG: any = {
    fileSize: '登録失敗しました。ファイルは4MB以下までとなります',
    fileType: '画像のPNGまたはJPEGファイル、資料のPowerPoint、Word文書またはPDFファイルのみアップロードしてください。',
    fileName: this.commonService.msg(MESSAGE_CODE.E00035)
  };

  listStatusChange: Object[] = [CHATSTATUSES.ADJUSTMENT, CHATSTATUSES.END];
  // // 画面.チャット入力フォーム
  c601ChatInputForm: FormGroup = this.formBuilder.group({
    start_implementation_date: this.formBuilder.control(CONSTANT.EMPTY_STRING),
    end_implementation_date: this.formBuilder.control(CONSTANT.EMPTY_STRING),
    status: this.formBuilder.control(CONSTANT.EMPTY_STRING),
  });

  c601SearchForm: FormGroup = this.formBuilder.group({
    member_class_sub_id: [],
    member_class_sub_id_2: [],
    member_municipalities: [],
    freeword: CONSTANT.EMPTY_STRING,
  });

  latestSearchForm: any = {};


  // 提案IDを格納
  suggestId: string = this.route.snapshot.params.suggest_id;

  // 提案詳細格納先
  proposaDetail: any;
  messageList: any[] = [];
  chatContent: string;
  listChatCommon: any[] = [];
  listChatCommonNew: any[] = [];
  listChatDetail: any[] = [];
  listChatDetailNew: any[] = [];
  matchId: any = null;
  consultationId: any = "";
  listMatchChatDetail: any;
  statusOld: any = -1;
  sendingStt: boolean;
  currentRoute: Subscription;
  classId: string = '';
  isShowDialogC431: boolean = false;
  // isShowDialogC341: boolean = false;
  statusValue: any[] = [];
  listChatMypage: any[] = [];
  oldStatus: any = "1";

  items: MenuItem[] = [];
  isEditMsg: boolean = false;
  numMsgEdit: number;
  chatContentEdit: string;
  messEdit: any;
  messEditOld: any;
  intervalListMsg: ReturnType<typeof setTimeout>;
  listCommonNew: any[];
  intervalListHistoryMsg: ReturnType<typeof setTimeout>;
  isChangingStatus: boolean = false;
  fileUploadedImage: File;
  fileUploadDocument: File;
  fileUploadedEditImage: File;
  fileUploadedEditDocument: File;
  //reset file upload
  fileUploadFlag: boolean = true;
  hasSelectedFile: boolean = true;
  insertFlag: boolean;
  acceptedFiles: string = ".pdf, .jpg, .png, .doc, .docx, .ppt, .pptx, .jpeg, .PDF, .JGP, .PNG, .DOC, .DOCX, .PPT, .PPTX, .JPEG"
  detailOpen: boolean = false;
  isMobile: boolean = true;
  menuIndex: number;
  editFlag: boolean = false;
  lastImg: number = 0;
  chatPosition: number = 0;
  icon_image_admin = "https://fukuoka-prod-file.s3.ap-northeast-1.amazonaws.com/common/admin/%E4%BA%8B%E5%8B%99%E5%B1%80%E3%82%A2%E3%82%A4%E3%82%B3%E3%83%B3.png";
  admin_name = "";
  admin_sub = "コーディネーター相談";
  isMatchingChat: boolean = true;
  accordion_member_class_sub: boolean = false;
  accordion_member_class_sub_id: boolean = false;
  accordion_member_class_sub_id_2: boolean = false;
  accordion_member_municipalities: boolean = false;
  urlCur: string = "pages/platform/c601"
  isShowMatch: string = "0";
  matchInfo: {};
  // セッション保存名
  sessionTagName: string = "c601SearchConditions";

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    public loginService: LoginService,
    private formBuilder: FormBuilder,
    private messageData: MessageData,
    private messageService: MessageService,
    private location: Location,
    private http: HttpClient,
  ) {
    super(route, commonService, dbOperationService, loadingState, loginService);
  }

  async ngOnInit(): Promise<void> {
    this.resetSearch();
    window.addEventListener("dragover", e => {
      e && e.preventDefault();
    }, false);
    window.addEventListener("drop", e => {
      e && e.preventDefault();
    }, false);
    window.addEventListener("resize", e => {
      if (this.numMsgEdit) {
        console.log('resize edit');
        const el = document.getElementById('editText' + this.numMsgEdit)
        el.scrollIntoView();
      } else {
        if (this.chatPosition > 0) {
          this.chatList.nativeElement.scrollTop = this.chatPosition;
          console.log('resize bottom');
        }
      }
    }, false);
    const innerWidth = window.innerWidth;
    if ((innerWidth > 450 && window.screen.orientation.type == 'portrait-primary') || (window.innerHeight > 450 && window.screen.orientation.type == 'landscape-primary')) {
      this.isMobile = false;
    }
    else {
      this.isMobile = true;
    }
    this.matchId = null;
    this.consultationId = "";
    if (this.router.url.startsWith("/pages/platform/c602")) {
      this.isMatchingChat = false;
      this.urlCur = "pages/platform/c602"
    }
    this.currentRoute = this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.matchId = this.route.snapshot.paramMap.get("id");
        if (this.matchId) {
          this.detailOpen = true;
          if (this.matchId.indexOf("_") >= 0) {
            const tmp = this.matchId.split("_")
            this.matchId = tmp[0];
            this.consultationId = tmp[1];
          } else {
            this.consultationId = ""
          }
        }
        this._initChatChannel(this.route.snapshot.paramMap.get("id"));
      }
    });

    this.matchId = this.route.snapshot.paramMap.get("id");
    if (this.matchId) {
      this.detailOpen = true;
      if (this.matchId.indexOf("_") >= 0) {
        const tmp = this.matchId.split("_")
        this.matchId = tmp[0];
        this.consultationId = tmp[1];
      } else {
        this.consultationId = ""
      }
    }
    this.loadingState.loadStart();
    if (await this.loginService.checkLoginUser()) {
      this.classId = this.loginService.getCurrentUser().class_id;
      this.member_id = this.getLoginMemberId();
      if (!this.isMatchingChat && this.classId !== ROLES.ADMIN) {
        this.loginService.logout(MESSAGE_CODE.E90000);
      }
        this._loadData();
    } else {
      this.loginService.logout(MESSAGE_CODE.E90000);
    }
    this.getSpecCodeList(
      DICID_NUMBER.MUNICIPALITIES,
      DICID_NUMBER.CLASS_SUB_ID_1,
      DICID_NUMBER.CLASS_SUB_ID_2,
      DICID_NUMBER.CLASS_SUB_ID_ADMIN
    );
    this.loadingState.loadSleepEnd(0.3);
  }
  onClickMenu(i, message) {
    this.items = [];
    this.items.push({
      label: "編集",
      icon: "pi pi-pencil",
      command: () => this.updateMsg(i, message),
    });

    this.items.push({
      label: "削除",
      icon: "pi pi-trash",
      command: () => this.deleteMsg(i, message),
    });

    return this.items;
  }
  public init() {
    this._loadData();
  }

  private async _loadData() {
    await this._initChat();
  }

  private _loadChatHistory(isload) {
    this.latestSearchForm = JSON.parse(
      JSON.stringify(this.c601SearchForm.value)
    );
    {
      this.latestSearchForm.member_class_sub_id =
        this.latestSearchForm.member_class_sub_id
          ? this.latestSearchForm.member_class_sub_id.toString()
          : CONSTANT.EMPTY_STRING;

      this.latestSearchForm.member_class_sub_id_2 =
        this.latestSearchForm.member_class_sub_id_2
          ? this.latestSearchForm.member_class_sub_id_2.toString()
          : CONSTANT.EMPTY_STRING;

      this.latestSearchForm.member_municipalities =
        this.latestSearchForm.member_municipalities
          ? this.latestSearchForm.member_municipalities.toString()
          : CONSTANT.EMPTY_STRING;

      this.latestSearchForm.freeword = this.latestSearchForm.freeword
        ? this.latestSearchForm.freeword.toString().trim()
        : CONSTANT.EMPTY_STRING;

    }

    if (this.matchId) {
      let checkSession1 = sessionStorage.getItem(this.sessionTagName);
      if (checkSession1) {
        let sessionSearchForm1 = JSON.parse(sessionStorage.getItem(this.sessionTagName));
        if (sessionSearchForm1.isSearch == "1"){
          // get session value
          this.latestSearchForm.freeword = sessionSearchForm1.freeword;
          this.latestSearchForm.member_class_sub_id = sessionSearchForm1.member_class_sub_id ? sessionSearchForm1.member_class_sub_id.toString() : CONSTANT.EMPTY_STRING;
          this.latestSearchForm.member_class_sub_id_2 = sessionSearchForm1.member_class_sub_id_2 ? sessionSearchForm1.member_class_sub_id_2.toString() : CONSTANT.EMPTY_STRING;
          this.latestSearchForm.member_municipalities = sessionSearchForm1.member_municipalities ? sessionSearchForm1.member_municipalities.toString() : CONSTANT.EMPTY_STRING;
        }
      }
    }
    const paramMerge = Object.assign({}, this.latestSearchForm, { isMatchingChat: this.isMatchingChat ? "1" : "0" });
    this.c601SearchForm.get("freeword")?.setValue(this.latestSearchForm.freeword);
    return new Promise<any>((resolve) => {
      // 画面ロードフラグをON(ロード中状態)
      if (isload) {
        this.loadingState.loadStart(API_URL_GENERATE_CHAT_LIST_2);
      }
      const table = "chat";
      // TODO: load chat history
      this.dbOperationService
        .getForkJoinDataNoTemplate(table, API_URL_GENERATE_CHAT_LIST_2, paramMerge)
        .subscribe((response: any) => {
          if(this.matchId){
            let checkSession = sessionStorage.getItem(this.sessionTagName);
            if (checkSession) {
              // get session value
              let sessionSearchForm = JSON.parse(sessionStorage.getItem(this.sessionTagName));
              this.c601SearchForm.get("freeword")?.setValue(sessionSearchForm.freeword);
              this.c601SearchForm.get("member_class_sub_id")?.setValue(sessionSearchForm.member_class_sub_id);
              this.c601SearchForm.get("member_class_sub_id_2")?.setValue(sessionSearchForm.member_class_sub_id_2);
              this.c601SearchForm.get("member_municipalities")?.setValue(sessionSearchForm.member_municipalities);
              // remove session
              sessionStorage.removeItem(this.sessionTagName);
            }
          }
         
          if (!this.commonService.checkNoneResponse(response)) {
            // list chat
            this.listChatCommon = response.body;
            this.admin_name = this.listChatCommon.length > 0 ? this.listChatCommon[0].admin_organization_name : "";
          } else {
            this.listChatCommon = new Array();
          }
          // 画面ロードフラグをOFF(ロード終了)
          if (isload) {
            this.loadingState.loadSleepEnd(0.3, API_URL_GENERATE_CHAT_LIST_2);
          }
          resolve(null);
        });
    });
  }

  private _loadChatHistoryNew() {
    // let c601SearchForm: any = JSON.parse(
    //   JSON.stringify(this.c601SearchForm.value)
    // );
    // {
    //   c601SearchForm.member_class_sub_id =
    //     c601SearchForm.member_class_sub_id
    //       ? c601SearchForm.member_class_sub_id.toString()
    //       : CONSTANT.EMPTY_STRING;

    //   c601SearchForm.member_class_sub_id_2 =
    //     c601SearchForm.member_class_sub_id_2
    //       ? c601SearchForm.member_class_sub_id_2.toString()
    //       : CONSTANT.EMPTY_STRING;

    //   c601SearchForm.member_municipalities =
    //     c601SearchForm.member_municipalities
    //       ? c601SearchForm.member_municipalities.toString()
    //       : CONSTANT.EMPTY_STRING;

    //   c601SearchForm.freeword = c601SearchForm.freeword
    //     ? c601SearchForm.freeword.toString().trim()
    //     : CONSTANT.EMPTY_STRING;

    // }
    const paramMerge = Object.assign({}, this.latestSearchForm, { isMatchingChat: this.isMatchingChat ? "1" : "0" });
    return new Promise<any>((resolve) => {
      // 画面ロードフラグをON(ロード中状態)

      const table = "chat";
      // TODO: load chat history
      this.dbOperationService
        .getForkJoinDataNoTemplateLastestRuncount(
          table,
          API_URL_GENERATE_CHAT_LIST_2,
          paramMerge
        )
        .subscribe((response: any) => {
          if (!this.commonService.checkNoneResponse(response)) {
            // list chat
            this.listChatCommonNew = response.body;
            this.admin_name = this.listChatCommonNew.length > 0 ? this.listChatCommonNew[0].admin_organization_name : "";
            this.listChatCommon.map((chat, index) => {
              this.listChatCommonNew.map((chatNew, indexNew) => {
                if (chatNew.match_id == chat.match_id && chatNew.consultation_id == chat.consultation_id) {
                  if (
                    Number(this.listChatCommon[index].count_unread) <
                    Number(this.listChatCommonNew[indexNew].count_unread)
                  ) {
                    if (chatNew.consultation_id) {
                      this.listChatCommon.splice(index, 1);
                      this.listChatCommon.unshift(chatNew);
                    } else {
                      const numberCountUnread = this.listChatCommon.filter(
                        (chat) => chat.consultation_id
                      ).length;
                      this.listChatCommon.splice(index, 1);
                      this.listChatCommon.splice(numberCountUnread, 0, chatNew);
                    }
                  } else if (
                    Number(this.listChatCommon[index].count_unread) >
                    Number(this.listChatCommonNew[indexNew].count_unread)
                  ) {
                    this.listChatCommon[index].count_unread =
                      this.listChatCommonNew[indexNew].count_unread;
                  }
                }
              });
            });
          } else {
            this.listChatCommonNew = new Array();
          }
          // 画面ロードフラグをOFF(ロード終了)

          resolve(null);
        });
    });
  }

  private _unsubscribeChat() {
    if (this.currentChat) {
      this.currentChat.unsubscribe();
      this.currentChat = null;
    }
  }

  private _initChatChannel(matchId) {
    // this._unsubscribeChat();
    // this.chatService.login(this.loginUser, this.matchId);
    // this.currentChat = this.chatService
    //   .getMessage()
    //   .subscribe((message: any) => {
    //     console.log(message);
    //     if (this.matchId == message.groupId) {
    //       this.messageList.push(message);
    //       if (!this.isLoginMember(message.memberId)) {
    //         this.updateChatStt(message.groupId, false);
    //       }
    //       this._sendMsgToTop(message.groupId);
    //       setTimeout(() => this._scrollToBottom(), 500);
    //     } else {
    //       this.listChatCommon.map((chat, index) => {
    //         if (chat.match_id == message.groupId) {
    //           ++this.listChatCommon[index].count_unread;
    //           this.listChatCommon.splice(index, 1);
    //           this.listChatCommon.unshift(chat);
    //           setTimeout(() => this._scrollPanelToTop(), 500);
    //         }
    //       });
    //     }
    //   });
    if (!this.intervalListMsg) {
      this.intervalListMsg = setInterval(async () => {
        if (!this.matchId) {
          clearInterval(this.intervalListMsg);
        } else {
          await this.intervalListChat();
        }
      }, 5000);
    };
  }

  private async intervalListChat() {
    if (this.consultationId == "") {
      await this.initGetMatchChatDetailNew(this.matchId, this.consultationId);
    }
    await this.initGetListChatNew(this.matchId, this.consultationId);
  }
  private async _initChat() {
    await this._loadChatHistory(true);
    if (!this.matchId) {
      return;
    }
    await this.updateChatStt(this.matchId, this.consultationId);
    await this.initDetailChat(this.matchId, true, this.consultationId);
  }

  ngOnDestroy() {
    // this._initChatChannel();
    if (this.intervalListMsg) {
      clearInterval(this.intervalListMsg);
    }
    if (this.intervalListHistoryMsg) {
      clearInterval(this.intervalListHistoryMsg);
    }

    // this._unsubscribeChat();
    if (this.currentRoute) {
      this.currentRoute.unsubscribe();
      this.currentRoute = null;
    }
    // this.chatService.disconnect();
  }
  ngAfterContentInit() {
    if (!this.intervalListHistoryMsg) {
      this.intervalListHistoryMsg = setInterval(async () => {
        await this._loadChatHistoryNew();
      }, 5000);
    }
  }
  async sendMessage(event) {
    await this.sendFile();
    let imageFile = null;
    if (this.fileUploadedImage !== null && this.fileUploadedImage !== undefined) {
      imageFile = this.fileUploadedImage.name
    }

    let documentFile = null;
    if (this.fileUploadDocument !== null && this.fileUploadDocument !== undefined) {
      documentFile = this.fileUploadDocument.name
    }

    if (this.chatContent == undefined) {
      this.chatContent = ''
    }
    else {
      this.chatContent = this.chatContent
    }

    if ((this.chatContent.trim() == CONSTANT.EMPTY_STRING) &&
      (this.fileUploadedImage == null || this.fileUploadedImage == undefined) &&
      (this.fileUploadDocument == null || this.fileUploadDocument == undefined)) {
      return;
    }
    this.sendingStt = true;

    const chatContent = {
      match_id: this.matchId,
      chat_comment: this.chatContent,
      image: (imageFile !== null && imageFile !== undefined) ? imageFile : '',
      document: (documentFile !== null && documentFile !== undefined) ? documentFile : '',
      orientation: 0,
      coordinator_id: this.consultationId
    };
    this.dbOperationService
      .insertData(API_URL_GENERATE_CHAT_LIST, chatContent)
      .subscribe(async (response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_INSERT);
        // レスポンス結果を判定
        if (this.commonService.checkInvalidValue(response)) {
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.WARN,
              summary: this.commonService.msg(MESSAGE_CODE.E00003),
              detail: this.commonService.msg(MESSAGE_CODE.E00026),
            })
          );
          this.matchId = null;
          this.consultationId = "";
          this.router.navigate([this.urlCur]);
        } else if (CONSTANT.EMPTY_STRING !== response.body.Message) {
          if (
            this.consultationId == "" &&
            this.listMatchChatDetail.status ==
            CHATSTATUSES.REQUEST.code &&
            this.messageList.length === 0 &&
            (this.listMatchChatDetail.needs_member_id ===
              this.member_id ||
              this.listMatchChatDetail.seeds_member_id ===
              this.member_id)
          ) {
            this.changeStatusProgress(chatContent.match_id, chatContent.coordinator_id);
          }
          this.initGetListChatNew(this.matchId, this.consultationId);

          // 正常終了の場合
          // this.chatService.sendMessage(this.chatContent);
          this._sendMsgToTop(this.matchId, this.consultationId);
          this.chatContent = CONSTANT.EMPTY_STRING;
          this.sendingStt = false;
          this.fileUploadDocument = null;
          this.fileUploadedImage = null

          // this._loadChatHistory();
          setTimeout(() => {
            this._scrollToBottom()
            this.editFlag = false;
          }, 500);
        } else {
          // 異常終了の場合

          // 異常終了メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.ERROR,
              summary: this.commonService.msg(MESSAGE_CODE.E00001),
              detail: this.commonService.msg(MESSAGE_CODE.E80002),
            })
          );
        }
      });
  }
  private _sendMsgToTop(matchId, consultationId) {
    if (consultationId) {
      const numberCountUnread = this.listChatCommon.filter(
        (chat) => Number(chat.count_unread) > 0 && chat.consultation_id
      ).length;
      this.listChatCommon.map((chat: any, index) => {
        if (matchId == chat.match_id && (chat.consultation_id == consultationId)) {
          this.listChatCommon.splice(index, 1);
          this.listChatCommon.splice(numberCountUnread, 0, chat);
          setTimeout(() => this._scrollPanelToTop(), 500);
        }
      });
      return;
    }
    const numberCountUnread = this.listChatCommon.filter(
      (chat) => Number(chat.count_unread) > 0 || chat.consultation_id
    ).length;
    this.listChatCommon.map((chat: any, index) => {
      if (matchId == chat.match_id && !chat.consultation_id) {
        this.listChatCommon.splice(index, 1);
        this.listChatCommon.splice(numberCountUnread, 0, chat);
        setTimeout(() => this._scrollPanelToTop(), 500);
      }
    });
  }
  private _scrollToBottom() {
    if (!this.editFlag) {
      const el = this.chatList.nativeElement;

      el.scrollTop += el.scrollHeight;
    }
  }

  private _scrollPanelToTop() {
    const el = this.listPanelChat.nativeElement;
    el.scrollTop -= el.scrollHeight;
  }

  /**
   * check login mêmber
   * @param memberId
   * @returns
   */
  isLoginMember(memberId: string) {
    return this.member_id === memberId;
  }

  formatTime(timestamp: number) {
    const time = moment(timestamp).format("YYYY/MM/DD HH:mm");
    return time;
  }

  /**
   * handle open to detail chat list
   */
  public async openDetailChat(match_id, countUnread, consultation_id) {
    if(!this.matchId){
      // Save the search value to the session even though the search event hasn't been executed.
      let objSearch = this.c601SearchForm.value;
      if(this.latestSearchForm.freeword == CONSTANT.EMPTY_STRING
        && this.latestSearchForm.member_class_sub_id == CONSTANT.EMPTY_STRING
        && this.latestSearchForm.member_class_sub_id_2 == CONSTANT.EMPTY_STRING
        && this.latestSearchForm.member_municipalities == CONSTANT.EMPTY_STRING
      ) {
        objSearch.isSearch = '0'; // not search
      } else {
        objSearch.isSearch = '1'; // searched
      }
      sessionStorage.setItem(this.sessionTagName, JSON.stringify(objSearch));
    } 
    this.detailOpen = true;
    const path_url = consultation_id != "" ? "_" + consultation_id : "";
    this.router.navigate([this.urlCur, match_id + path_url]);
    if (!match_id || !this.matchId) {
      return;
    }
    this.messageList = [];
    if (countUnread !== "0") {
      await this.updateChatStt(match_id, consultation_id);
    }
    if (consultation_id == "") {
      await this.initGetMatchChatDetail(match_id, consultation_id);
    }
    await this.initGetListChat(match_id, consultation_id);
    this.numMsgEdit = null;
  }
  /**
   * init open detail chat
   * @param match_id
   * @returns
   */
  public async initDetailChat(match_id, isLoad, consultation_id) {
    if (!match_id || !this.matchId) {
      return;
    }
    this.messageList = [];
    if (consultation_id == "") {
      await this.initGetMatchChatDetail(match_id, consultation_id);
    }
    await this.initGetListChat(match_id, consultation_id, true, isLoad);
    const path_url = consultation_id != "" ? "_" + consultation_id : "";
    this.router.navigate([this.urlCur, match_id + path_url]);
  }

  /**
   * init get list chat from member
   *
   */
  public initGetListChat(match_id, consultation_id, isScroll: boolean = true, isload: boolean = true) {
    return new Promise<any>((resolve) => {
      // 画面ロードフラグをON(ロード中状態)
      if (isload) {
        this.loadingState.loadStart(API_URL_GENERATE_CHAT_LIST);
      }
      const table = "chat_detail";
      const sub = consultation_id != "" ? "_" + consultation_id : "";
      const matchId = { MatchId: match_id + sub };

      // TODO: load chat list
      this.dbOperationService
        .getForkJoinDataNoTemplate(table, API_URL_GENERATE_CHAT_LIST, matchId)
        .subscribe(async (response: any) => {
          if (this.commonService.checkInvalidValue(response)) {
            // 警告メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.WARN,
                summary: this.commonService.msg(MESSAGE_CODE.E00003),
                detail: this.commonService.msg(MESSAGE_CODE.E00026),
              })
            );
          } else if (!this.commonService.checkNoneResponse(response)) {
            // list chat
            this.listChatDetail = response.body.reverse();
            if (isScroll) {
              setTimeout(() => {
                this._scrollToBottom();
                this.editFlag = false
              }, 0);
            }
          } else {
            this.listChatDetail = new Array();
            this.editFlag = false
          }
          this.listChatDetail.forEach((item, i) => { if (item.chat_image) { this.lastImg = i } });
          // 画面ロードフラグをOFF(ロード終了)
          if (isload) {
            this.loadingState.loadSleepEnd(0.3, API_URL_GENERATE_CHAT_LIST);
          }
        });
      resolve(null);
    });
  }

  /**
   * init get list chat from member
   *
   */
  public initGetListChatNew(match_id, consultationId: any) {
    return new Promise<any>((resolve) => {
      const table = "chat_detail";
      const sub = consultationId != "" ? "_" + consultationId : "";
      const matchId = { MatchId: match_id + sub };

      // TODO: load chat list
      this.dbOperationService
        .getForkJoinDataNoTemplate(table, API_URL_GENERATE_CHAT_LIST, matchId)
        .subscribe((response: any) => {
          if (!this.commonService.checkNoneResponse(response)) {
            // list chat
            this.listChatDetailNew = response.body.reverse();
            if (this.listChatDetail.length < this.listChatDetailNew.length) {
              const numberChatNew =
                this.listChatDetailNew.length - this.listChatDetail.length;
              this.messageList = this.listChatDetailNew.splice(
                this.listChatDetail.length,
                numberChatNew
              );
              this.messageList.map((chat) => {
                if (!this.isLoginMember(chat.chat_member_id_comment)) {
                  this.updateChatStt(chat.chat_match_id, false);
                }
              });
              this.listChatDetail = this.listChatDetail.concat(
                this.messageList
              );
              // setTimeout(() => this._scrollToBottom(), 0);
              setTimeout(() => this._scrollToBottom(), 500);
            } else if (
              this.listChatDetail.length > this.listChatDetailNew.length
            ) {
              this.listChatDetail = this.listChatDetailNew;
              setTimeout(() => this._scrollToBottom(), 500);
            } else {
              this.listChatDetailNew.map((chat, index) => {
                if (
                  chat.chat_chat_comment !==
                  this.listChatDetail[index].chat_chat_comment
                ) {
                  this.listChatDetail[index].chat_chat_comment =
                    chat.chat_chat_comment;
                }
                if (!this.numMsgEdit) {
                  if (chat.chat_image.name != this.listChatDetail[index].chat_image.name) {
                    this.listChatDetail[index].chat_image =
                      chat.chat_image;
                  }
                  if (chat.chat_document.name != this.listChatDetail[index].chat_document.name) {
                    this.listChatDetail[index].chat_document =
                      chat.chat_document;
                  }
                }

              });
            }
          } else {
            this.listChatDetailNew = new Array();
            setTimeout(() => this._scrollToBottom(), 500);
          }
        });
      resolve(null);
    });
  }
  /**
   * init get match chat detail from member
   *
   */
  public initGetMatchChatDetailNew(match_id, consultationId) {
    return new Promise<any>((resolve) => {
      // TODO: load chat history
      // const sub = consultationId != "" ? "_" + consultationId : "";
      this.dbOperationService
        .getNoTemplateDisplayData(API_URL_MATCH_CHAT_DETAIL, match_id, false)
        .subscribe((response: any) => {
          if (this.commonService.checkInvalidValue(response)) {
            // 警告メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.WARN,
                summary: this.commonService.msg(MESSAGE_CODE.E00003),
                detail: this.commonService.msg(MESSAGE_CODE.E00026),
              })
            );
            this.matchId = null;
            this.consultationId = "";
            this.listMatchChatDetail = new Array();
            this.statusOld = -1;
            this.location.back();
            this.loadingState.loadSleepEnd(0.3, API_URL_MATCH_CHAT_DETAIL);
            return;
          } else if (!this.commonService.checkNoneResponse(response)) {
            // list chat
            this.listMatchChatDetail = response.body;
            this.statusOld = this.listMatchChatDetail.status
            this.c601ChatInputForm
              .get("start_implementation_date")
              .setValue(this.listMatchChatDetail?.start_implementation_date);
            this.c601ChatInputForm
              .get("end_implementation_date")
              .setValue(this.listMatchChatDetail?.end_implementation_date);
            if (
              this.c601ChatInputForm.get("status").value !== CHATSTATUSES.END.code &&
              !this.isChangingStatus
            ) {
              this.c601ChatInputForm
                .get("status")
                .setValue(this.listMatchChatDetail?.status);
            }
          } else {
            this.listMatchChatDetail = new Array();
            this.statusOld = -1;
          }
        });
      resolve(null);
    });
  }
  /**
   * init get match chat detail from member
   *
   */
  public initGetMatchChatDetail(match_id, consultationId, isload: boolean = true) {
    return new Promise<any>((resolve) => {
      // 画面ロードフラグをON(ロード中状態)
      if (isload) {
        this.loadingState.loadStart(API_URL_MATCH_CHAT_DETAIL);
      }
      // TODO: load chat history
      // const sub = consultationId != "" ? "_" + consultationId : "";
      this.dbOperationService
        .getNoTemplateDisplayData(API_URL_MATCH_CHAT_DETAIL, match_id, false)
        .subscribe((response: any) => {
          if (this.commonService.checkInvalidValue(response)) {
            // 警告メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.WARN,
                summary: this.commonService.msg(MESSAGE_CODE.E00003),
                detail: this.commonService.msg(MESSAGE_CODE.E00026),
              })
            );
            this.matchId = null;
            this.consultationId = "";
            this.listMatchChatDetail = new Array();
            this.statusOld = -1;
            this.router.navigate([this.urlCur]);
            this.loadingState.loadSleepEnd(0.3, API_URL_MATCH_CHAT_DETAIL);
            return;
          } else if (!this.commonService.checkNoneResponse(response)) {
            if (
              this.classId == ROLES.NURSERY &&
              response.body.needs_member_id != this.member_id
            ) {
              this.loginService.logout();
            }
            if (
              (this.classId == ROLES.SCHOOL) &&
              response.body.seeds_member_id != this.member_id
            ) {
              this.loginService.logout();
            }
            // list chat
            this.listMatchChatDetail = response.body;
            this.statusOld = this.listMatchChatDetail.status
            this.c601ChatInputForm
              .get("start_implementation_date")
              .setValue(this.listMatchChatDetail?.start_implementation_date);
            this.c601ChatInputForm
              .get("end_implementation_date")
              .setValue(this.listMatchChatDetail?.end_implementation_date);
            this.c601ChatInputForm
              .get("status")
              .setValue(this.listMatchChatDetail?.status);
          } else {
            this.listMatchChatDetail = new Array();
            this.statusOld = -1;
          }
          // 画面ロードフラグをOFF(ロード終了)
          if (isload) {
            this.loadingState.loadSleepEnd(0.3, API_URL_MATCH_CHAT_DETAIL);
          }
        });
      resolve(null);
    });
  }
  // public checkNewChat(match_id) {
  //   if (!match_id) {
  //     return false;
  //   }
  //   return (
  //     this.listChatCommon
  //       .map((chatcommon) => chatcommon.match_id)
  //       .indexOf(match_id) == -1
  //   );
  // }

  /**
   * update status of chat
   */
  public updateChatStt(matchId, consultationId, isload: boolean = true) {
    return new Promise<any>((resolve) => {
      if (isload) {
        this.loadingState.loadStart(API_URL_CHAT_STATUS);
      }

      // TODO: load chat history
      const sub = consultationId != "" ? "_" + consultationId : "";
      this.dbOperationService
        .updateData(API_URL_CHAT_STATUS, matchId + sub)
        .subscribe((response: any) => {
          // レスポンス結果を判定
          if (this.commonService.checkInvalidValue(response)) {
            // this.messageData.toastMessage(
            //   new ToastMessageData({
            //     severity: TOAST.WARN,
            //     summary: this.commonService.msg(MESSAGE_CODE.E00003),
            //     detail: this.commonService.msg(MESSAGE_CODE.E00026),
            //   })
            // );
            // this.router.navigate(["pages/platform/c601"])
          } else if (API_RESPONSE.SUCCESS == response.body.Message) {
            // 正常終了の場合
            this.listChatCommon.map((chat, index) => {
              if (chat.match_id == matchId && chat.consultation_id === consultationId) {
                this.listChatCommon[index].count_unread = "0";
              }
            });
          } else if (this.commonService.checkInvalidValue(response)) {
            this.loadingState.loadSleepEnd(0.3, API_URL_CHAT_STATUS);
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.WARN,
                summary: this.commonService.msg(MESSAGE_CODE.E00003),
                detail: this.commonService.msg(MESSAGE_CODE.E00026),
              })
            );
            this.router.navigate([this.urlCur]);
            this._loadChatHistory(true);
            return;
          } else {
            // 異常終了の場合

            // 異常終了メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.ERROR,
                summary: this.commonService.msg(MESSAGE_CODE.E00001),
                detail: this.commonService.msg(MESSAGE_CODE.E80002),
              })
            );
          }
          if (isload) {
            // 画面ロードフラグをOFF(ロード終了)
            this.loadingState.loadSleepEnd(0.3, API_URL_CHAT_STATUS);
          }
          resolve(null);
        });
    });
  }

  public showTimeDialog(): void {
    this.isShowTimeDialog = true;
  }

  public updateCloseDialog(): void {
    this.isShowTimeDialog = false;
  }

  public updateDateSelect(date: any): void {
    if (date == 'error') {
      this.router.navigate([this.urlCur])
      return;
    }
    this.initGetMatchChatDetail(this.matchId, this.consultationId);
    this.c601ChatInputForm
      .get("start_implementation_date")
      .setValue(date?.start_implementation_date);
    this.c601ChatInputForm
      .get("end_implementation_date")
      .setValue(date?.end_implementation_date);
  }

  public formatDateJapan(dateTime: any): string {
    if (dateTime) {
      let date = new Date(dateTime);
      let lang = "en",
        year = date.toLocaleString(lang, { year: "numeric" }),
        month = date.toLocaleString(lang, { month: "numeric" }),
        day = date.toLocaleString(lang, { day: "numeric" });
      return `${year}年${month}月${day}日`;
    }
    return ``;
  }

  //change stt of firts message
  private changeStatusProgress(matchId: number, consultation_id: any) {
    if (consultation_id != "") {
      return;
    }
    const statusProgress = "1";
    this.dbOperationService
      .updateData(API_URL_UPDATE_MATCH_STATUS, matchId, {
        status: statusProgress,
      })
      .subscribe((response) => {
        // APIレスポンスの判定
        if (!this.commonService.checkRunningNormallyResponse(response)) {
          // APIが正常終了の場合
          this.messageService.add({
            severity: TOAST.ERROR,
            summary: this.commonService.msg(MESSAGE_CODE.E00002),
            detail: this.commonService.msg(MESSAGE_CODE.E00006),
          });
        } else {
          this.initGetMatchChatDetail(matchId, consultation_id);
        }
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadEnd(LOADING_KEY.DATA_UPDATE);

        // 親画面に更新対象IDを設定
      });
  }

  cancelConfirm(event) {
    this.isChangingStatus = false;
    this.c601ChatInputForm.controls["status"].setValue(this.statusOld);
  }
  public changeStatus(event) {
    if (event.value == CHATSTATUSES.END.code) {
      this.isChangingStatus = true;
      this.confirmRejectMatchDialogComponent.updateMatchStatus(
        API_URL_UPDATE_MATCH_STATUS,
        this.matchId,
        CHATSTATUSES.END.code
      );
    }
    if (event.value == CHATSTATUSES.ADJUSTMENT.code) {
      this.isChangingStatus = true;
      this.confirmRejectMatchDialogComponent.updateMatchStatus(
        API_URL_UPDATE_MATCH_STATUS,
        this.matchId,
        CHATSTATUSES.ADJUSTMENT.code
      );
    }
  }

  redirectListChat(event) {
    this.isChangingStatus = false;
    if (this.consultationId == "") {
      this.initGetMatchChatDetail(this.matchId, this.consultationId);
    }
  }

  public setClassStatus(matchStatus: any) {
    let classActiveColor = CONSTANT.EMPTY_STRING;
    switch (matchStatus) {
      case CHATSTATUSES.REQUEST.code:
        classActiveColor = "yellow-color";
        break;
      case CHATSTATUSES.ADJUSTMENT.code:
        classActiveColor = "green-color";
        break;
      case CHATSTATUSES.DECISION.code:
        classActiveColor = "blue-color";
        break;
      case CHATSTATUSES.IMPLEMENTED.code:
        classActiveColor = "bg-red-color";
        break;
      case CHATSTATUSES.END.code:
        classActiveColor = "default-color";
        break;

      default:
        classActiveColor = "text-default-color";
        break;
    }

    return classActiveColor;
  }

  public setClassStatusDropdown(matchStatus) {
    let classActiveColor = CONSTANT.EMPTY_STRING;
    switch (matchStatus) {
      case CHATSTATUSES.ADJUSTMENT.code:
        classActiveColor = "green-dropdown-color";
        break;
      case CHATSTATUSES.REQUEST.code:
        classActiveColor = "yellow-dropdown-color";
        break;
      case CHATSTATUSES.DECISION.code:
        classActiveColor = "blue-dropdown-color";
        break;
      case CHATSTATUSES.IMPLEMENTED.code:
        classActiveColor = "red-dropdown-color";
        break;
      case CHATSTATUSES.END.code:
        classActiveColor = "default-dropdown-color";
        break;
      default:
        break;
    }
    return classActiveColor;
  }
  public setClassBgColor(message) {
    let classBackground = CONSTANT.EMPTY_STRING;
    let positionMsg = CONSTANT.EMPTY_STRING;
    if (this.isLoginMember(message.chat_member_id_comment)) {
      positionMsg = "me";
    }
    if (this.consultationId !== "") {
      switch (message.member_class_id) {
        case ROLES.ADMIN:
          classBackground = "yellow-bg-chat";
          break;
        case ROLES.NURSERY:
          classBackground = "pink-bg-chat";
          break;
        case ROLES.SCHOOL:
          classBackground = "green-bg-chat";
          break;
        default:
          break;
      }
      return [classBackground, positionMsg];
    }
    if (
      this.member_id == message.chat_member_id_comment &&
      this.classId == ROLES.ADMIN
    ) {
      classBackground = "yellow-bg-chat";
    } else if (
      message.chat_member_id_comment == message.match_seeds_member_id
    ) {
      classBackground = "green-bg-chat";
    } else if (
      message.chat_member_id_comment == message.match_needs_member_id
    ) {
      classBackground = "pink-bg-chat";
    } else {
      classBackground = "yellow-bg-chat";
    }
    return [classBackground, positionMsg];
  }

  public setClassBgColorSocket(memberId, classId) {
    let classBackground = CONSTANT.EMPTY_STRING;
    let positionMsg = CONSTANT.EMPTY_STRING;
    if (this.isLoginMember(memberId)) {
      positionMsg = "me";
    }
    switch (classId) {
      case ROLES.ADMIN:
        classBackground = "yellow-bg-chat";
        break;
      case ROLES.SCHOOL:
        classBackground = "pink-bg-chat";
        break;
      case ROLES.NURSERY:
        classBackground = "green-bg-chat";
        break;
      case ROLES.PROVIDER_INDIVIDUAL:
        classBackground = "green-bg-chat";
        break;
      default:
        classBackground = "yellow-bg-chat";
        break;
    }

    return [classBackground, positionMsg];
  }

  number(value: string) {
    return Number(value);
  }
  //update message
  updateMsg(i: number, message: any) {
    this.numMsgEdit = i;
    this.chatContentEdit = message.chat_chat_comment;
    this.messEdit = JSON.parse(JSON.stringify(message));
    this.messEditOld = JSON.parse(JSON.stringify(message));
    this.scrollToElement('editText' + i, true);

  }

  //cancel Edit mode message
  cancelEdit() {
    // emit event numMsgEdit and call CancelEditMode when accepted
    this.confirmRejectMatchDialogComponent.cancelEditMsg();
  }

  CancelEditMode(numMsg: number) {
    this.isChangingStatus = false;
    this.numMsgEdit = null;
  }

  CancelEditMode2(message) {
    this.isChangingStatus = false;
    this.numMsgEdit = null;
    message.chat_image = this.messEditOld.chat_image;
    message.chat_document = this.messEditOld.chat_document;
  }

  async editMessage(message: any, index: number, type: string) {
    this.editFlag = true;
    await this.editSendFile()
    if ((this.chatContentEdit.trim() == CONSTANT.EMPTY_STRING) &&
      (this.fileUploadedImage == null || this.fileUploadedImage == undefined) &&
      (this.fileUploadDocument == null || this.fileUploadDocument == undefined) &&
      (message.chat_image == "") &&
      (message.chat_document == "")) {
      this.messageData.toastMessage(
        new ToastMessageData({
          severity: TOAST.ERROR,
          summary: this.commonService.msg(MESSAGE_CODE.E00034),
        })
      );
      return;
    }
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(API_URL_GENERATE_CHAT_LIST);
    const chatContent = {
      chat_comment: this.chatContentEdit,
      image: (this.messEdit?.chat_image?.name !== null && this.messEdit?.chat_image?.name !== undefined) ? this.messEdit?.chat_image?.name : '',
      document: (this.messEdit?.chat_document?.name !== null && this.messEdit?.chat_document?.name !== undefined) ? this.messEdit?.chat_document?.name : '',
      orientation: 0
    };
    this.dbOperationService
      .updateData(API_URL_GENERATE_CHAT_LIST, message.chat_chat_id, chatContent)
      .subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, API_URL_GENERATE_CHAT_LIST);
        console.log(response);
        // レスポンス結果を判定
        if (this.commonService.checkInvalidValue(response)) {
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.WARN,
              summary: this.commonService.msg(MESSAGE_CODE.E00003),
              detail: this.commonService.msg(MESSAGE_CODE.E00026),
            })
          );
          this.router.navigate([this.urlCur]);
        } else if (CONSTANT.EMPTY_STRING !== response.body.Message) {
          if (type === "DB") {
            this.listChatDetail[index].chat_chat_comment = this.chatContentEdit;
            this.listChatDetail[index].chat_image = response.body.chat_image;
            this.listChatDetail[index].chat_document = response.body.chat_document;
            // this.initGetListChat(this.matchId,false,false)
            setTimeout(() => {
              this.scrollToElement('msg' + index)
              this.numMsgEdit = null;
            }, 500);
          }
          // 異常終了メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.SUCCESS,
              summary: this.commonService.msg(MESSAGE_CODE.T00002),
            })
          );
          this.numMsgEdit = null;
        } else {
          // 異常終了メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.ERROR,
              summary: this.commonService.msg(MESSAGE_CODE.E00001),
              detail: this.commonService.msg(MESSAGE_CODE.E80002),
            })
          );
          this.numMsgEdit = null;
        }
      });
  }

  // delete message
  deleteMsg(index: number, message: any) {
    this.confirmRejectMatchDialogComponent.deleteMessage(
      index,
      message.chat_chat_id,
      API_URL_GENERATE_CHAT_LIST
    );
  }

  handleDeleteFromList(index) {
    this.isChangingStatus = false;
    this.listChatDetail.splice(index, 1);
  }

  reset() {
    this.isChangingStatus = false;
    this.matchId = null;
    this.consultationId = "";
    this.router.navigate([this.urlCur], {});
  }
  changeStatusFail() {
    this.cancelConfirm(null)
    this.messageData.toastMessage(
      new ToastMessageData({
        severity: TOAST.ERROR,
        summary: this.commonService.msg(MESSAGE_CODE.E00001),
        detail: this.commonService.msg(MESSAGE_CODE.E80002),
      })
    );

  }

  public moveScreenByMatchType(match_ns_id: string, match_type: string, isShowMatch: string) {
    this.matchId = match_ns_id;
    this.isShowDialogC431 = true;
    this.isShowMatch = isShowMatch;
    this.matchInfo = {
      desired_content: this.listMatchChatDetail.desired_content,
      desired_ldatetime: this.listMatchChatDetail.desired_ldatetime,
      desired_location: this.listMatchChatDetail.desired_location,
      desired_lpeople_number: this.listMatchChatDetail.desired_lpeople_number,
      manager_name: this.listMatchChatDetail.manager_name,
      class_sub_id: this.listMatchChatDetail.class_sub_id,
      organization_name: this.listMatchChatDetail.organization_name,
      municipalities: this.listMatchChatDetail.municipalities,
      address_building: this.listMatchChatDetail.address_building,
      tel: this.listMatchChatDetail.tel
    }
    // if (match_type == MATCH_TYPE.AGENDA_SOLUTION) {
    //   this.isShowDialogC331 = true;
    // } else if (match_type == MATCH_TYPE.AGENDA_NEED) {
    //   this.isShowDialogC341 = true;
    // }
  }
  public closeDialogC431(openDialog: boolean): void {
    this.isShowDialogC431 = openDialog;
  }
  // public closeDialogC341(openDialog: boolean): void {
  //   this.isShowDialogC341 = openDialog;
  // }
  public searchChatListCondition() { }

  getListStatusChange(status: any, type: any) {
    switch (status) {
      case CHATSTATUSES.REQUEST.code:
        return [CHATSTATUSES.REQUEST, CHATSTATUSES.END];
      case CHATSTATUSES.ADJUSTMENT.code:
        return [CHATSTATUSES.ADJUSTMENT, CHATSTATUSES.END];
      case CHATSTATUSES.DECISION.code:
        return [CHATSTATUSES.ADJUSTMENT, CHATSTATUSES.DECISION];
      case CHATSTATUSES.IMPLEMENTED.code:
        return [CHATSTATUSES.IMPLEMENTED, CHATSTATUSES.END];
      case CHATSTATUSES.END.code:
        return [CHATSTATUSES.ADJUSTMENT, CHATSTATUSES.END];
      default:
        return []
    }
  }
  // processData(data: any, type: any) {
  //   const dv = new DataView(data);
  //   let offset = 0, recess = 0;
  //   const pieces = [];
  //   let i = 0;
  //   console.log(1);

  //   if (dv.getUint16(offset) == 0xffd8) {
  //     console.log(2);

  //     offset += 2;
  //     let app1 = dv.getUint16(offset);
  //     offset += 2;
  //     while (offset < dv.byteLength) {
  //       if (app1 == 0xffe1) {

  //         pieces[i] = { recess: recess, offset: offset - 2 };
  //         recess = offset + dv.getUint16(offset);
  //         i++;
  //       }
  //       else if (app1 == 0xffda) {
  //         break;
  //       }
  //       offset += dv.getUint16(offset);
  //       app1 = dv.getUint16(offset);
  //       offset += 2;
  //     }
  //     if (pieces.length > 0) {
  //       const newPieces = [];
  //       pieces.forEach(function (v) {
  //         newPieces.push(data.slice(v.recess, v.offset));
  //       }, this);
  //       newPieces.push(data.slice(recess));
  //       const br = new Blob(newPieces, { type: type });
  //       console.log(3);

  //       return br
  //     }
  //   }
  //   console.log(4);

  //   return null
  // }

  processData2(data: any, type: any) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = function (e: any) {
        // const orientation = 6;

        const canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        const ctx = canvas.getContext("2d");
        let x = 0;
        let y = 0;
        ctx.save();
        // if (orientation == 2) {
        //   x = -canvas.width;
        //   ctx.scale(-1, 1);
        // } else if (orientation == 3) {
        //   x = -canvas.width;
        //   y = -canvas.height;
        //   ctx.scale(-1, -1);
        // } else if (orientation == 3) {
        //   x = -canvas.width;
        //   y = -canvas.height;
        //   ctx.scale(-1, -1);
        // } else if (orientation == 4) {
        //   y = -canvas.height;
        //   ctx.scale(1, -1);
        // } else if (orientation == 5) {
        //   canvas.width = image.height;
        //   canvas.height = image.width;
        //   ctx.translate(canvas.width, canvas.height / canvas.width);
        //   ctx.rotate(Math.PI / 2);
        //   y = -canvas.width;
        //   ctx.scale(1, -1);
        // } else if (orientation == 6) {
        let heightCanvas = image.height
        let widthCanvas = image.width
        if (heightCanvas > 400 || widthCanvas > 400) {
          if (image.height / image.width > 1) {
            widthCanvas = image.width * 400 / image.height
            heightCanvas = 400
          } else {
            heightCanvas = image.height * 400 / image.width
            widthCanvas = 400
          }
        }
        // console.log(widthCanvas);
        // console.log(heightCanvas);
        canvas.width = widthCanvas;
        canvas.height = heightCanvas;
        // ctx.translate(canvas.width, canvas.height / canvas.width);
        // ctx.rotate(Math.PI / 2);
        // } else if (orientation == 7) {
        //   canvas.width = image.height;
        //   canvas.height = image.width;
        //   ctx.translate(canvas.width, canvas.height / canvas.width);
        //   ctx.rotate(Math.PI / 2);
        //   x = -canvas.height;
        //   ctx.scale(-1, 1);
        // } else if (orientation == 8) {
        //   canvas.width = image.height;
        //   canvas.height = image.width;
        //   ctx.translate(canvas.width, canvas.height / canvas.width);
        //   ctx.rotate(Math.PI / 2);
        //   x = -canvas.height;
        //   y = -canvas.width;
        //   ctx.scale(-1, -1);
        // }
        ctx.drawImage(image, x, y, widthCanvas, heightCanvas);
        ctx.restore();
        // console.log(type);

        const dataURL = canvas.toDataURL(type);
        resolve(dataURL);

      };
      image.src = data;
    });
  }

  // readImage(fileObj: any) {
  //   return new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  //     reader.onload = (e: any) => {
  //       resolve(e.target.result);
  //     };

  //     reader.onerror = (e) => {
  //       reject(false);
  //     };

  //     reader.readAsArrayBuffer(fileObj);
  //   });
  // };


  readImage2(fileObj: any) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        resolve(e.target.result);
      };

      reader.onerror = (e) => {
        reject(false);
      };

      reader.readAsDataURL(fileObj);
    });
  };

  async urlToFile(url: any, filename: any, mimeType: any) {
    if (url.startsWith('data:')) {
      let arr = url.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[arr.length - 1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      const file = new File([u8arr], filename, { type: mime || mimeType });
      return Promise.resolve(file);
    }
    const res = await fetch(url);
    const buf = await res.arrayBuffer();
    return new File([buf], filename, { type: mimeType });
  }

  async uploadFile(event) {
    this.fileUploadedImage = null;
    this.fileUploadDocument = null
    let fileObj: File = event.files[0];

    if (fileObj.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || //.docx
      fileObj.type == 'application/msword' || //.doc
      fileObj.type == 'application/pdf' || //.pdf
      fileObj.type == 'application/vnd.openxmlformats-officedocument.presentationml.presentation' || //.pptx
      fileObj.type == 'application/vnd.ms-powerpoint' || //.ppt
      fileObj.type == 'image/jpeg' || //image jpeg
      fileObj.type == 'image/png' || //image png
      fileObj.type == 'image/jpg') { // image jpg
      fileObj = fileObj
    }
    else {
      this.messageService.add({
        severity: TOAST.ERROR,
        summary: this.chatFileErrorMSG.fileType,
      });
      return
    }

    if (fileObj.size > CONSTANT.MAX_FILE_SIZE) {
      this.messageService.add({
        severity: TOAST.ERROR,
        summary: this.chatFileErrorMSG.fileSize,
      });

      return;
    }

    if (this.checkFileNameLengthC601(fileObj.name)) {
      this.messageService.add({
        severity: TOAST.ERROR,
        summary: this.chatFileErrorMSG.fileName,
      });

      return;
    }

    if (['image/jpeg', 'image/png', 'image/jpg'].includes(fileObj.type)) {
      let orientationImage: any = 0
      orientationImage = await this.getOrientation(fileObj);
      if ([2, 3, 4, 5, 6, 7, 8].includes(orientationImage)) {
        console.log("orientationImage");

        // let dataBu = await this.readImage(fileObj)
        let dataImage = await this.readImage2(fileObj)
        const rawDataImage: any = await this.processData2(dataImage, fileObj.type)

        // const raw = this.processData(dataBu, fileObj.type)
        // const file = new File([raw], fileObj.name, { type: fileObj.type });
        // fileObj = file
        await this.urlToFile(rawDataImage, fileObj.name, { type: fileObj.type })
          .then(function (file) {
            fileObj = file;
          });
        // this.getOrientation(fileObj, function(orientation) {
        //   console.log("orientation: " + orientation);
        //   self.orientationImage = orientation;
        // });
      }
    }

    if (fileObj.type.includes('image')) {
      this.fileUploadedImage = fileObj;
    }
    else {
      this.fileUploadDocument = fileObj;
    }

    console.log(this.fileUploadedImage)
    console.log(this.fileUploadDocument)
  }

  async editFile(event, message: any) {
    message.chat_image = ''
    message.chat_document = ''
    this.fileUploadedEditImage = null;
    this.fileUploadedEditDocument = null
    let fileObj: File = event.files[0];

    if (fileObj.size > CONSTANT.MAX_FILE_SIZE) {
      this.messageService.add({
        severity: TOAST.ERROR,
        summary: this.chatFileErrorMSG.fileSize,
      });
      return;
    }

    if (fileObj.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || //.docx
      fileObj.type == 'application/msword' || //.doc
      fileObj.type == 'application/pdf' || //.pdf
      fileObj.type == 'application/vnd.openxmlformats-officedocument.presentationml.presentation' || //.pptx
      fileObj.type == 'application/vnd.ms-powerpoint' || //.ppt
      fileObj.type == 'image/jpeg' || //image jpeg
      fileObj.type == 'image/png' || //image png
      fileObj.type == 'image/jpg') { // image jpg
      fileObj = fileObj
    }
    else {
      this.messageService.add({
        severity: TOAST.ERROR,
        summary: this.chatFileErrorMSG.fileType,
      });
      return
    }

    if (this.checkFileNameLengthC601(fileObj.name)) {
      this.messageService.add({
        severity: TOAST.ERROR,
        summary: this.chatFileErrorMSG.fileName,
      });

      return;
    }

    if (['image/jpeg', 'image/png', 'image/jpg'].includes(fileObj.type)) {
      let orientationImage: any = 0
      orientationImage = await this.getOrientation(fileObj);
      if ([2, 3, 4, 5, 6, 7, 8].includes(orientationImage)) {
        console.log("orientationImage");

        // let dataBu = await this.readImage(fileObj)
        let dataImage = await this.readImage2(fileObj)
        const rawDataImage: any = await this.processData2(dataImage, fileObj.type)

        // const raw = this.processData(dataBu, fileObj.type)
        // const file = new File([raw], fileObj.name, { type: fileObj.type });
        // fileObj = file
        await this.urlToFile(rawDataImage, fileObj.name, { type: fileObj.type })
          .then(function (file) {
            fileObj = file;
          });
        // this.getOrientation(fileObj, function(orientation) {
        //   console.log("orientation: " + orientation);
        //   self.orientationImage = orientation;
        // });
      }
    }
    if (fileObj.type.includes('image')) {
      this.fileUploadedEditImage = fileObj;
      message.chat_image =
      {
        name: '',
        url: ''
      }
      message.chat_image.name = this.fileUploadedEditImage.name
    }
    else {
      this.fileUploadedEditDocument = fileObj;
      message.chat_document =
      {
        name: '',
        url: ''
      }
      message.chat_document.name = this.fileUploadedEditDocument.name
    }
    this.messEdit = JSON.parse(JSON.stringify(message));

    console.log(this.fileUploadedEditImage)
    console.log(this.fileUploadedEditDocument)
  }

  removeFile(event) {
    this.fileUploadDocument = null;
    this.fileUploadedImage = null;
  }

  removeEditFile(event, message: any) {
    message.chat_image = ''
    message.chat_document = ''
    this.messEdit = JSON.parse(JSON.stringify(message));
  }

  public async editSendFile() {
    this.loadingState.loadStart();
    // 登録ボタン押下フラグをONにする(登録、戻るボタン非活性化)
    this.insertFlag = true;

    if (
      this.fileUploadedEditDocument !== null && this.fileUploadedEditDocument !== undefined
    ) {
      await this.uploadFiletoS3(
        "chat_document",
        this.fileUploadedEditDocument,
        "chat"
      );
    }

    if (
      this.fileUploadedEditImage !== null && this.fileUploadedEditImage !== undefined
    ) {
      await this.uploadFiletoS3(
        "chat_image",
        this.fileUploadedEditImage,
        "chat"
      );
    }
    this.loadingState.loadEnd();
  }

  public async sendFile() {
    this.loadingState.loadStart();
    // 登録ボタン押下フラグをONにする(登録、戻るボタン非活性化)
    this.insertFlag = true;

    if (
      this.fileUploadDocument !== null && this.fileUploadDocument !== undefined
    ) {
      await this.uploadFiletoS3(
        "chat_document",
        this.fileUploadDocument,
        "chat"
      );
    }

    if (
      this.fileUploadedImage !== null && this.fileUploadedImage !== undefined
    ) {
      await this.uploadFiletoS3(
        "chat_image",
        this.fileUploadedImage,
        "chat"
      );
    }
    this.loadingState.loadEnd();
  }

  private async uploadFiletoS3(id: any, fileUploaded: File, tableId) {
    const uploadInfo: any = await this._getUploadInfo(
      id,
      fileUploaded.name,
      tableId
    );
    if (
      uploadInfo.url === undefined ||
      uploadInfo.url === null ||
      uploadInfo.url.length === 0 ||
      uploadInfo.url.indexOf("s3.amazonaws.com") === -1
    ) {
      this.messageService.add({
        severity: TOAST.ERROR,
        summary: this.commonService.msg(MESSAGE_CODE.I00005),
        detail: this.commonService.msg(MESSAGE_CODE.E00002),
      });
      return;
    }

    await this._uploadToS3(uploadInfo, fileUploaded);
  }

  private _getUploadInfo(code, filename, tableId) {
    let fileType;
    let colName;
    const url = this.commonService.url(API_URL_GET_UPLOAD_URL);
    if (code == "chat_document") {
      fileType = "file";
      colName = "chat_document";
    } else if (code == "chat_image") {
      fileType = "image";
      colName = "chat_image";
    }

    return this.http
      .get(url, {
        params: {
          tablename: tableId,
          filetype: fileType,
          colname: colName,
          filename: encodeURIComponent(filename),
          code: "",
        },
      })
      .toPromise();
  }

  getOrientation = (file: File) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event: ProgressEvent) => {
        if (!event.target) {
          resolve(null);
        }
        const file = event.target as FileReader;
        const view = new DataView(file.result as ArrayBuffer);
        if (view.getUint16(0, false) != 0xFFD8) {
          resolve(-2);
        }
        const length = view.byteLength
        let offset = 2;
        while (offset < length) {
          if (view.getUint16(offset + 2, false) <= 8) resolve(-1);
          let marker = view.getUint16(offset, false);
          offset += 2;
          if (marker == 0xFFE1) {
            if (view.getUint32(offset += 2, false) != 0x45786966) {
              resolve(-1);
            }

            let little = view.getUint16(offset += 6, false) == 0x4949;
            offset += view.getUint32(offset + 4, little);
            let tags = view.getUint16(offset, little);
            offset += 2;
            for (let i = 0; i < tags; i++) {
              if (view.getUint16(offset + (i * 12), little) == 0x0112) {
                resolve(view.getUint16(offset + (i * 12) + 8, little));
              }
            }
          } else if ((marker & 0xFF00) != 0xFF00) {
            break;
          }
          else {
            offset += view.getUint16(offset, false);
          }
        }
        resolve(-1);
      };

      reader.readAsArrayBuffer(file);
    });
  }

  private async _uploadToS3(uploadInfo, fileUpload) {
    return new Promise<any>((resolve) => {
      const uploadUrl = uploadInfo.url;
      const fields: any = uploadInfo.fields;

      const formData = new FormData();
      Object.entries(uploadInfo.fields).forEach(([k, v]) => formData.append(k, String(v)));
      formData.append("file", fileUpload, fileUpload.name);

      this.http
        .post(uploadUrl, formData, { observe: "response" })
        .pipe(map((res: HttpResponse<any>) => res))
        .subscribe((res) => resolve(res))
    });
  }

  downloadFile(url: string) {
    window.open(url, "_blank");
  }

  resetChat() {
    this.chatContent = ''
    this.fileUploadedImage = null
    this.fileUploadDocument = null
  }
  viewImg(path: string, name: string) {
    this.imgPreviewComponent.viewImg(path, name);
  }
  showEditChatMobile(i, status) {
    this.isMobile && status != '4' ? this.menuIndex = i : null;
  }
  onImgLoad(i) {
    if (i == this.numMsgEdit || this.numMsgEdit === null) {
      console.log('scroll to img edit on imgload');
      this.scrollToElement('chatImg' + i);
    } else if (i >= this.lastImg) {
      this.lastImg = i;
      this._scrollToBottom();
    }
    // if (orientation == 6) {
    //   const naturalWidth = event.currentTarget.naturalWidth;
    //   const naturalHeight = event.currentTarget.naturalHeight;
    //   const yshift = -100;
    //   const style = `transform:rotate(90deg) translateY(${yshift}%); transform-origin: top left; width: ${naturalWidth}px; height: ${naturalHeight}px`
    //   document.getElementById('chatImg' + i).setAttribute("style",style);
    // }
  }
  scrollToElement(id: string, focus: boolean = false) {
    setTimeout(() => {
      const el = document.getElementById(id)
      el.scrollIntoView();
      if (focus) {
        el.focus();
      }
    }, 500);
  }
  onScrollChat() {
    this.chatPosition = this.chatList.nativeElement.scrollTop;
  }
  public openConsultationDialog(mode): void {
    const userInfo = this.loginService.getCurrentUser();

    // 内閣府承認ダイアログ表示
    this.consultationDialogComponent.openConsultationDialog(this.matchId, {
      municipalities: userInfo.municipalities,
      organization_name: userInfo.organization_name,
      oneword_message: this.listMatchChatDetail.oneword_message,
      contente: mode == 'edit' ? this.listMatchChatDetail.contente : '',
      status: mode == 'edit' ? this.listMatchChatDetail.consult_status : '',
      type: mode == 'edit' ? "detail_c502" : '',
      contente_2: ''
    });
  }
  closeConsultationDialog(openDialog: boolean): void { }

  private resetSearch() {
    this.c601SearchForm.reset();
    this.accordion_member_class_sub = false;
    this.accordion_member_class_sub_id = false;
    this.accordion_member_class_sub_id_2 = false;
    this.accordion_member_municipalities = false;
  }

  // isDisabledTab(controlName) {
    // const value = this.c601SearchForm.get(controlName).value;
    // if (value == null) {
    //   return false;
    // } else if (value.length > 0) return true;
    // else return false;
  // }
  public checkLargeCategory(
    type: string,
    list: any,
    controlName: string
  ): void {
    // 画面.検索フォーム.カテゴリを取得
    let getList = this.c601SearchForm.get(controlName).value;

    // チェック対象小項目リストからコード値のみ取得
    let spCodeList = this.commonService.createArrayGetArrayObject(
      list,
      "sp_code"
    );
    let result = [];
    // 該当のカテゴリコードを全て削除してresult変数に格納
    if (getList) {
      result = getList.filter((value) => !spCodeList.includes(value));
    }

    // チェック状態の判定

    // チェック状態の場合
    if (type == "checkAll") {
      // result変数に選択したカテゴリコードリストを追加
      result = result.concat(spCodeList);
    } else {
      result = result.filter((val) => !spCodeList.includes(val));
    }

    // 画面.検索フォーム.地域に設定
    this.c601SearchForm.get(controlName).setValue(result);
  }
}